module.exports = __webpack_public_path__ + "img/e-book.b529f2c.jpg";